/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_9_AInputs */

const en_tut_tr_9_a = /** @type {(inputs: Tut_Tr_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every guest visit needs fresh approval, and the host has to be connected and present in that room. Check the check-in list and press **Terima**. Remember too that a link is valid for 24 hours and a single visit lasts at most two hours.`)
};

const id_tut_tr_9_a = /** @type {(inputs: Tut_Tr_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunjungan tamu perlu persetujuan baru setiap kali, dan host harus sedang tersambung serta berada di ruang tersebut. Periksa daftar check-in lalu tekan **Terima**. Ingat juga bahwa tautan berlaku 24 jam dan satu kunjungan berlangsung paling lama dua jam.`)
};

/**
* | output |
* | --- |
* | "Every guest visit needs fresh approval, and the host has to be connected and present in that room. Check the check-in list and press **Terima**. Remember too..." |
*
* @param {Tut_Tr_9_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_9_a = /** @type {((inputs?: Tut_Tr_9_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_9_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_9_a(inputs)
	return en_tut_tr_9_a(inputs)
});